import { request } from '../../utility/services/request';
import {Service} from '../base';
import objectToFormData from '../../utility/Utils';

class SolicitudService extends Service {
	create({
		modelo_id,
		tipo_solicitud,
		file,
		data,
		password,
		comentario
	}) {
		const body = {
			tipo_solicitud,
			file,
			id: modelo_id,
			password
		};
		if (tipo_solicitud === 'delito') {
			console.log('estoy seteando los delitos');
			body.delitos = data;
		}
		return request('POST', this.baseUrl, objectToFormData(body), null, true);
	};

	update(id, body) {

		return request('POST', `${this.baseUrl}/autorizacion/${id}`, body);
	};

	getSolicitudesPendientes(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		const requestId = this.requestPrefixId && `${this.requestPrefixId}-get`;
		return request(
			'GET',
			`${this.baseUrl}/pendientes?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`,
			null,
			requestId
		);
	}

	getMisSolicitudes(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		const requestId = this.requestPrefixId && `${this.requestPrefixId}-get`;
		return request(
			'GET',
			`${this.baseUrl}/misSolicitudes?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`,
			null,
			requestId
		);
	}

}

export default SolicitudService;